<template>
  <v-layout>
    <v-flex grow style="flex-basis: 300px">
      <v-subheader>
        {{ leftLabel }}
      </v-subheader>
      <select multiple class="selectList">
        <option
          v-for="item in leftItems"
          :key="item.id"
          :value="item"
          :selected="isLeftSelected(item)"
          :class="['listItem', { isSelected: isLeftSelected(item) }]"
          @click.prevent="onClickLeftItem(item)"
        >
          {{ item.name }}
        </option>
      </select>
    </v-flex>
    <v-flex justify-center align-self-center shrink>
      <v-layout column>
        <v-btn
          :disabled="disabledAddButton"
          icon
          large
          @click="onClickAddButton"
        >
          <v-icon x-large>arrow_right</v-icon>
        </v-btn>
        <v-btn
          icon
          large
          :disabled="disabledRemoveButton"
          @click="onClickRemoveButton"
        >
          <v-icon x-large>arrow_left</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
    <v-flex grow style="flex-basis: 300px">
      <v-subheader>
        {{ rightLabel }}
      </v-subheader>
      <select multiple class="selectList">
        <option
          v-for="item in rightItems"
          :key="item.id"
          :value="item"
          :selected="isRightSelected(item)"
          :class="['listItem', { isSelected: isRightSelected(item) }]"
          @click.prevent="onClickRightItem(item)"
        >
          {{ item.name }}
        </option>
      </select>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    leftLabel: {
      type: String,
      default: '',
    },
    rightLabel: {
      type: String,
      default: '',
    },
    // selectの中身は親で管理する
    leftItems: {
      type: Array,
      default: () => [],
    },
    rightItems: {
      type: Array,
      default: () => [],
    },
    disabledAddButton: {
      type: Boolean,
      default: false,
    },
    disabledRemoveButton: {
      type: Boolean,
      default: false,
    },
    // selectedを親で制御したければ使う
    // 親から値が渡ってこないならこのコンポーネント内のdataを使うようになってる
    selectedLeftItems: {
      type: Array,
      default: () => [],
    },
    selectedRightItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedLeftItemsInData: [],
      selectedRightItemsInData: [],
    }
  },
  computed: {
    selectedLeft: {
      get() {
        return this.selectedLeftItems.length === 0
          ? this.selectedLeftItemsInData
          : this.selectedLeftItems
      },
      set(item) {
        let result = {}
        result.old = this.selectedLeftItemsInData
        this.toggleLeft(item)
        result.new = this.selectedLeftItemsInData
        this.$emit('changeLeftSelectedItems', result)
      },
    },
    selectedRight: {
      get() {
        return this.selectedRightItems.length === 0
          ? this.selectedRightItemsInData
          : this.selectedRightItems
      },
      set(item) {
        let result = {}
        result.old = this.selectedRightItemsInData
        this.toggleRight(item)
        result.new = this.selectedRightItemsInData
        this.$emit('changeLeftSelectedItems', result)
      },
    },
  },
  methods: {
    toggle(list, item) {
      const index = list.findIndex(g => g.id === item.id)
      if (index >= 0) {
        list.splice(index, 1)
      } else {
        list.push(item)
      }
      return list
    },
    isSelected(list, item) {
      return list.findIndex(g => g.id === item.id) !== -1
    },
    isLeftSelected(item) {
      return this.isSelected(this.selectedLeft, item)
    },
    isRightSelected(item) {
      return this.isSelected(this.selectedRight, item)
    },
    onClickLeftItem(item) {
      this.$emit('clickLeftItem', item)
      this.toggleLeft(item)
    },
    onClickRightItem(item) {
      this.$emit('clickRightItem', item)
      this.toggleRight(item)
    },
    toggleLeft(item) {
      this.selectedLeftItemsInData = this.toggle(
        this.selectedLeftItemsInData,
        item,
      )
    },
    toggleRight(item) {
      this.selectedRightItemsInData = this.toggle(
        this.selectedRightItemsInData,
        item,
      )
    },
    onClickAddButton() {
      this.$emit('add', this.selectedLeft)
      this.clearSelected()
    },
    onClickRemoveButton() {
      this.$emit('remove', this.selectedRight)
      this.clearSelected()
    },
    clearSelected() {
      this.selectedLeftItemsInData = []
      this.selectedRightItemsInData = []
    },
  },
}
</script>

<style scoped lang="scss">
.selectList {
  width: 100%;
  height: 150px;
  border: 1px solid black;
  overflow-y: scroll;
}

.listItem {
  cursor: pointer;

  &.isSelected {
    background-color: rgba(#1976d2, 0.6);
  }
}
</style>
